import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["status", "className", "children"];
import { NotificationAlert, NotificationError, NotificationInfo, StatusCheck } from '@repay/cactus-icons';
import { colorStyle, textStyle } from '@repay/cactus-theme';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { omitMargins } from '../helpers/omit';
var StatusPropType = PropTypes.oneOf(['success', 'warning', 'error', 'info']);
var statusMap = {
  success: 'successLight',
  warning: 'warningLight',
  error: 'errorLight',
  info: 'lightContrast'
};
var iconMap = {
  success: StatusCheck,
  warning: NotificationAlert,
  error: NotificationError,
  info: NotificationInfo
};

var Noop = function Noop() {
  return null;
};

var StatusMessageBase = function StatusMessageBase(props) {
  var _omitMargins = omitMargins(props),
      status = _omitMargins.status,
      className = _omitMargins.className,
      children = _omitMargins.children,
      rest = _objectWithoutProperties(_omitMargins, _excluded);

  var StatusIcon = iconMap[status] || Noop;
  return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
    role: "alert",
    className: className
  }), /*#__PURE__*/React.createElement(StatusIcon, {
    "aria-hidden": "true",
    mr: 2,
    verticalAlign: "-2px"
  }), /*#__PURE__*/React.createElement("span", null, children));
};

var StatusMessage = /*#__PURE__*/styled(StatusMessageBase).withConfig({
  displayName: "StatusMessage"
})(["padding:2px 4px;position:relative;box-sizing:border-box;overflow-wrap:break-word;display:inline-block;", ";", " ", ""], textStyle('small'), function (p) {
  return colorStyle(p, statusMap[p.status]);
}, margin);
StatusMessage.propTypes = {
  status: StatusPropType.isRequired
};
export default StatusMessage;